var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{class:_vm.data.staticClass,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9.596","height":"7.5","viewBox":"0 0 9.596 7.5"}},[_c('g',{attrs:{"transform":"translate(0 -10.918)"}},[_c('path',{staticClass:"a",style:({
        fill: _vm.props.color
      }),attrs:{"d":"M3.371,15.9l4.98-4.98L9.6,12.193,3.371,18.418,0,15.048l1.275-1.275Z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }